import React from 'react';
export function AnnouncementBar() {
  return <aside className="sticky top-0 z-50 flex h-9 w-full items-center justify-center bg-brand-navy px-3 text-white shadow-sm" data-id="element-20" data-mp="2tgqpao3xs0lk">
      <p className="truncate text-[10px] font-extrabold uppercase tracking-[0.1em] sm:text-[11px]" data-id="element-21" data-mp="ju3lovdqfez5">
        Des ressources pour enseigner la musique en français
      </p>
    </aside>;
}